export default __webpack_public_path__ + "209657b18c08bd35e2274693d6dfa832.svg";